import { ReactTabs } from "../../../../components/ReactTabs";
import Container from "../../../../components/components-ui/Container/Container";
import Action from "./Tabs/Action";
import { useParams } from "react-router-dom";
import ImagensColeta from "./Tabs/ImagensColeta";

export default function PainelLocal() {
  const { id } = useParams();
  const title = [
    {
      title: "Dados da Coleta",
    },
    {
      title: "Imagens da Coleta",
    },
  ];
  const content = [
    {
      component: <Action />,
    },
    {
      component: <ImagensColeta />,
    },
  ];
  return (
    <Container>
      <h3> {id ? "Edição de Coleta" : "Nova Coleta"} </h3>
      <ReactTabs title={title} content={content} />
    </Container>
  );
}
